var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"sb-nav-fixed"},[_c('div',{attrs:{"id":"layoutSidenav"}},[_c('SideBar'),_c('div',{attrs:{"id":"layoutSidenav_content"}},[_c('NavBar'),_c('router-view'),_c('Footer')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }